import React from 'react';

import { TrailerAudioSettingsPopup } from './component';

interface Props {
    contentId?: string;
    onSubtitleSizeSettingsClick: () => void;
}

export const TrailerAudioSettingsPopupContainer = ({
    contentId,
    onSubtitleSizeSettingsClick,
}: Props) => {
    if (!contentId) {
        return null;
    }

    return (
        <TrailerAudioSettingsPopup
            contentId={contentId}
            onSubtitleSizeSettingsClick={onSubtitleSizeSettingsClick}
        />
    );
};
